import React, { useState } from 'react';

const PromptBox: React.FC<{
  title: string;
  suggestions: string[];
}> = ({ title, suggestions }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="mb-2">
      {isExpanded ? (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 shadow-sm transition-all duration-300 ease-in-out">
          <div className="flex items-center justify-between mb-1.5">
            <div className="flex items-center gap-1.5">
              <svg
                className="w-3.5 h-3.5 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                />
              </svg>
              <h3 className="font-semibold text-xs text-blue-800">{title}</h3>
            </div>
            <button
              type="button"
              className="text-xs font-medium text-blue-600 hover:text-blue-700 transition-opacity focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded"
              onClick={() => setIsExpanded(false)}
              aria-expanded={isExpanded}
            >
              Hide
            </button>
          </div>
          <ul className="space-y-1 list-none">
            {suggestions.map((suggestion, i) => (
              <li
                key={i}
                className="flex items-start gap-1.5 text-xs leading-snug text-blue-700"
              >
                <span className="flex-shrink-0 w-1 h-1 rounded-full bg-current mt-1 opacity-60" />
                <span>{suggestion}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <button
          type="button"
          className="group flex items-center gap-1.5 text-xs font-medium text-blue-600 hover:text-blue-700 transition-opacity focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded px-2 py-1"
          onClick={() => setIsExpanded(true)}
        >
          <svg
            className="w-3.5 h-3.5 transition-transform group-hover:scale-110"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
            />
          </svg>
          Show Suggested Questions
        </button>
      )}
    </div>
  );
};

export default PromptBox;
